import { IClauseInfo, IClausePopupLovs } from '.';
import { IAbstractRecord } from '@models';
import {
  enumListAsRecordObject,
  lookupListAsRecordObject,
} from '@utils/graph-utils';

export function LookupToList(data: IAbstractRecord): IClausePopupLovs {
  const lovs: IClausePopupLovs = {
    lines: {},
    statuses: {},
  };

  if (!data) {
    return lovs;
  }

  lovs.statuses = enumListAsRecordObject(
    data.PlanConfigManagement_ClauseStatuses.enumValues
  );

  lovs.lines = lookupListAsRecordObject(
    data.PlanConfigManagement.queries.allLines,
    false,
    'planConfigManagement_Line_Id',
    'planConfigManagement_Line_Name'
  );

  return lovs;
}

export function mapToClauseInfo(
  data: IAbstractRecord,
  lineId: string,
  lineName: string
): IClauseInfo {
  return {
    clauseId: '',
    lineId: lineId,
    lineName: lineName,
    clauseName:
      data?.PlanConfigManagement?.entities?.clause?.views
        ?.PlanConfigManagement_all?.properties?.Name,
    clauseExternalCode:
      data?.PlanConfigManagement?.entities?.clause?.views
        ?.PlanConfigManagement_all?.properties?.ExternalCode,
    clauseStatus:
      data?.PlanConfigManagement?.entities?.clause?.views
        ?.PlanConfigManagement_all?.properties?.Status,
    clauseDescription:
      data?.PlanConfigManagement?.entities?.clause?.views
        ?.PlanConfigManagement_all?.properties?.Description,
  };
}
